import { errorPageContent } from '@tock/shared/utils/errorContent';
import React, { Component, ErrorInfo, FunctionComponent } from 'react';

const ErroBoundaryContent: FunctionComponent<React.PropsWithChildren<{}>> = () => {
  return (
    <div
      dangerouslySetInnerHTML={{
        __html: errorPageContent`Tock is temporarily unavailable and we are working hard to restore services. We’re sorry for the inconvenience and appreciate your patience.
    `,
      }}
    ></div>
  );
};

type Props = {
  children?: React.ReactNode;
};

class ErrorBoundary extends Component<Props> {
  state = { hasError: false };

  static getDerivedStateFromError(error: unknown) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // You can also log the error to an error reporting service
    window.LOGGER?.error(error.message, error);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <ErroBoundaryContent />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
